import { AxiosResponse } from "axios";
import { Module } from "vuex";
import { SET_ERRORMSG, SET_BANK_ACCOUNT, SET_BANK_ACCOUNTS } from "../mutation_types";
import {
    CLEAR_BANK_ACCOUNTS_ISLOADING,
    DELETE_BANK_ACCOUNT,
    EDIT_BANK_ACCOUNT,
    GET_BANK_ACCOUNTS,
    REGISTER_BANK_ACCOUNT,
    TOGGLE_BANK_ACCOUNT_IS_ACTIVE,
} from "../action_types";
import { StateObject } from "@/dtos/state.dto";
import BankAccountService from "@/services/recipient_account";
import {
    EditBankAccount,
    GetBankAccounts,
    RegisterBankAccount,
    ToggleBankAccountIsActive,
} from "@/dtos/recipient_account.dto";

const recipientAccount: Module<any, {}> = {
    state: {
        bankAccount: { data: null, isLoading: false },
        bankAccounts: { data: null, metaData: null, isLoading: false },
    },
    getters: {
        bankAccount: (state) => state.bankAccount,
        bankAccounts: (state) => state.bankAccounts,
    },
    mutations: {
        [SET_BANK_ACCOUNT]: (state: { bankAccount: StateObject }, payload: any) => {
            if (payload.data !== undefined) state.bankAccount.data = payload.data;
            state.bankAccount.isLoading = payload.isLoading;
        },
        [SET_BANK_ACCOUNTS]: (state: { bankAccounts: StateObject }, payload: any) => {
            if (payload.data !== undefined) state.bankAccounts.data = payload.data;
            if (payload.metaData !== undefined) state.bankAccounts.metaData = payload.metaData;
            state.bankAccounts.isLoading = payload.isLoading;
        },
    },
    actions: {
        [GET_BANK_ACCOUNTS]: async ({ commit }, payload: GetBankAccounts) => {
            commit(SET_BANK_ACCOUNTS, { data: null, isLoading: true });
            const result: AxiosResponse = await BankAccountService.getBankAccounts(
                payload ?? {},
            );
            if (result?.data?.status) {
                commit(SET_BANK_ACCOUNTS, {
                    data: result.data.data,
                    metaData: result.data.metaData,
                    isLoading: false,
                });
                return true;
            }
            commit(SET_BANK_ACCOUNTS, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [REGISTER_BANK_ACCOUNT]: async ({ commit }, payload: RegisterBankAccount) => {
            commit(SET_BANK_ACCOUNT, { data: null, isLoading: true });
            const result: AxiosResponse = await BankAccountService.registerBankAccount(payload);
            if (result?.data?.status) {
                commit(SET_BANK_ACCOUNT, { data: result.data.data, isLoading: false });
                return true;
            }
            commit(SET_BANK_ACCOUNT, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [EDIT_BANK_ACCOUNT]: async ({ commit }, payload: EditBankAccount) => {
            commit(SET_BANK_ACCOUNT, { isLoading: true });
            const result: AxiosResponse = await BankAccountService.editBankAccount(payload);
            if (result?.data?.status) {
                commit(SET_BANK_ACCOUNT, { data: result.data.data, isLoading: false });
                return true;
            }
            commit(SET_BANK_ACCOUNT, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [TOGGLE_BANK_ACCOUNT_IS_ACTIVE]: async (
            { commit, state },
            payload: ToggleBankAccountIsActive,
        ) => {
            commit(SET_BANK_ACCOUNT, { isLoading: true });
            const result: AxiosResponse = await BankAccountService.toggleIsActive(payload);
            if (result?.data?.status) {
                // Patch the row in place so the table reflects the new state
                // without a full refetch.
                if (state.bankAccounts.data) {
                    const idx = state.bankAccounts.data.findIndex(
                        (a: any) => a.id === result.data.data.id,
                    );
                    if (idx >= 0)
                        state.bankAccounts.data[idx].isActive = result.data.data.isActive;
                }
                commit(SET_BANK_ACCOUNT, { data: result.data.data, isLoading: false });
                return true;
            }
            commit(SET_BANK_ACCOUNT, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [DELETE_BANK_ACCOUNT]: async ({ commit }, payload: string) => {
            commit(SET_BANK_ACCOUNT, { isLoading: true });
            const result: AxiosResponse = await BankAccountService.deleteBankAccount(payload);
            if (result?.data?.status) {
                commit(SET_BANK_ACCOUNT, { data: result.data.data, isLoading: false });
                return true;
            }
            commit(SET_BANK_ACCOUNT, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [CLEAR_BANK_ACCOUNTS_ISLOADING]: ({ commit }) => {
            commit(SET_BANK_ACCOUNT, { isLoading: false });
            commit(SET_BANK_ACCOUNTS, { isLoading: false });
        },
    },
};

export default recipientAccount;
